import { Reveal } from "./Reveal";
import { colorOf, dayShort } from "../../lib/content";
import { useLang } from "../../lib/i18n";

const Row = ({ cls, p, cur }) => {
  const { t, lang, pick } = useLang();
  const c = colorOf(cls.color);
  const isDil = cls.program === "dillusions";
  const days = [...new Set(cls.sessions.map((s) => s.day))].map((d) => dayShort(d, lang)).join(" · ");
  const sub = [pick(cls, "style"), isDil ? pick(cls, "tag") : pick(cls, "ages")].filter(Boolean).join(" · ");
  return (
    <li className="grid grid-cols-[1fr_auto] items-center gap-x-4 gap-y-1 border-t border-white/[0.07] py-4 sm:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)_minmax(0,1.2fr)]" data-testid={`price-row-${cls.id}`}>
      <div className="col-span-2 flex min-w-0 items-start gap-3 sm:col-span-1">
        <span className="mt-2 h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: c, boxShadow: `0 0 12px ${c}` }} />
        <div className="min-w-0">
          <p className="font-display text-lg font-bold leading-tight text-white">{pick(cls, "title")}</p>
          <p className="text-sm text-zinc-400">{sub}</p>
        </div>
      </div>
      <p className="ps-5 font-mono text-[13px] text-zinc-300 sm:ps-0">{days || t.scheduleTba}</p>
      <div className="text-end">
        <p className="font-display text-lg font-bold text-white" data-testid={`price-row-fee-${cls.id}`}>
          {isDil ? `${p.monthly_fee} ${cur}` : pick(cls, "fee") || t.askUs}
        </p>
        {isDil && <p className="text-xs text-zinc-400">{t.dilFeeNote(p.reduced_fee, p.full_threshold - 1, cur)}</p>}
      </div>
    </li>
  );
};

export const PriceList = ({ classes, pricing }) => {
  const { t, pick } = useLang();
  const cur = pick(pricing, "currency");
  return (
    <Reveal>
    <div className="rounded-2xl border border-white/10 bg-[#12121A] p-5 sm:p-7" data-testid="price-list">
      <h3 className="mb-4 font-display text-xl font-bold uppercase tracking-tight text-white">{t.priceList}</h3>
      <div className="hidden grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)_minmax(0,1.2fr)] pb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 sm:grid">
        <span>{t.colClass}</span><span>{t.colDays}</span><span className="text-end">{t.colFee}</span>
      </div>
      <ul>{[...classes].sort((a, b) => (a.program === "dillusions") - (b.program === "dillusions")).map((c) => <Row key={c.id} cls={c} p={pricing} cur={cur} />)}</ul>
    </div>
    </Reveal>
  );
};
